import { ModuleWithProviders, NgModule } from '@angular/core';
import { ISessionIdleConfig } from 'app/session-idle/interfaces/session-idle-config.interface';
import { SessionIdleService } from 'app/session-idle/session-idle.service';
import { SESSION_IDLE_CONFIG } from 'app/session-idle/tokens/session-config.token';

@NgModule({
    imports: [],
    declarations: [],
    providers: [],
    exports: [],
})
export class SessionIdleModule {
    // Use forRoot to expose a configurable singleton.
    public static forRoot(config: ISessionIdleConfig): ModuleWithProviders<SessionIdleModule> {
        if (!config) {
            config = {
                warningDurationMs: 18 * 1000,
                timeoutDurationMs: 20 * 1000,
            };
        }

        return {
            ngModule: SessionIdleModule,
            providers: [
                SessionIdleService,
                { provide: SESSION_IDLE_CONFIG, useValue: config },
            ],
        };
    }
}
